import {
  Avatar,
  Flex,
  InlineStack,
  Panel,
  PanelActions,
  PanelHeader,
  PanelTitle,
  Stack,
  Text,
} from '@customerio/pluma-components/react';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { Logo } from '@/components/page/logo';
import { useMemo } from 'react';
import { useAuthQuery } from '@/services/auth';
import { isEmptyString } from '@/utils/string';

export const AuthLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const auth = useAuthQuery();

  const userInfo = useMemo(() => {
    const firstName = auth.data?.user?.first_name;
    const lastName = auth.data?.user?.last_name;
    const name = [firstName, lastName]
      .filter((name): name is string => typeof name === 'string' && !isEmptyString(name))
      .join(' ');

    return {
      name,
      email: auth.data?.user?.email ?? undefined,
    };
  }, [auth.data?.user]);

  return (
    <Flex
      position="fixed"
      backgroundColor="base"
      alignItems="center"
      justifyContent="center"
      p="300"
      style={{
        inset: 0,
        minHeight: '100vh',
      }}
    >
      <Panel style={{ width: '100%', maxWidth: '600px', boxShadow: themeVars.depth['surface-2'] }}>
        <PanelHeader withBorder>
          <PanelTitle>
            <Logo width={120} />
          </PanelTitle>
          <PanelActions>
            <InlineStack alignBlock="center" gap="100" wrap="nowrap">
              <Stack gap="025" style={{ textAlign: 'right' }}>
                <Text size="s" weight="medium" color="base">
                  {userInfo.name}
                </Text>
                <Text size="xs" color="subtle">
                  {userInfo.email}
                </Text>
              </Stack>
              <Avatar name={userInfo.name} email={userInfo.email} statusIndicatorColor="success" />
            </InlineStack>
          </PanelActions>
        </PanelHeader>
        {children}
      </Panel>
    </Flex>
  );
};
